import Chip from '@mui/material/Chip';

import { type AccessoryStock } from '@/services/accessories/types';

/**
 * Stock state, in the words a buyer can act on.
 *
 * "On order" is warehouse language; "Next shipment" tells them what has to
 * happen before they can have it. The label carries the whole meaning and the
 * colour only repeats it, so the chip survives being read aloud or seen by
 * someone who cannot separate amber from grey (§50).
 */
const labels: Record<AccessoryStock, string> = {
  'in-stock': 'In Kampala',
  'on-order': 'Next shipment',
  'made-to-order': 'Ordered for you',
};

/**
 * Unlike the vehicles' `AvailabilityChip`, this draws in every state.
 *
 * A car that is simply available needs no chip — available is what a listing
 * means. An accessory is different: "in Kampala today" against "six weeks
 * away" is the difference between two otherwise identical parts, and hiding
 * the good case would leave the shopper unable to tell which cards had been
 * judged and which had not.
 */
export function AccessoryStockChip({ stock }: { stock: AccessoryStock }) {
  return (
    <Chip
      size="small"
      label={labels[stock]}
      color={stock === 'in-stock' ? 'success' : stock === 'on-order' ? 'warning' : 'default'}
      sx={{ fontWeight: 700 }}
    />
  );
}
